import { conditionCodeToName } from '../../../condition/conditionCodeToName';
import { ICustomInspectionTypeSettings } from '../ICustomInspectionTypeSettings';

const translation = {
    en: {
        inspectionStandard: {
            verificatieBerekening: 'Verification calculation',
        },
    },
    nl: {
        inspectionStandard: {
            verificatieBerekening: 'Verificatie berekening',
        },
    },
};

export function conditionScoreToScore(conditionScore?: number | null | string) {
    if (conditionScore === undefined || conditionScore === null) {
        return null;
    }
    return conditionScore.toString();
}

export function conditionScoreToColorCode(conditionScore?: number | null | string) {
    return conditionCodeToName(conditionScore);
}

export const verificatieBerekeningSettings: ICustomInspectionTypeSettings = {
    inspectionStandardType: 'verificatieBerekening',
    translation,
    conditionScoreToScore,
    conditionScoreToColorCode,
};
